module.exports = __webpack_public_path__ + "img/bienvenida-background.73c314da.png";